import { v3Get } from '../axios.instance.V3';
import type { ApiResponse } from '../types';
import routes from '@/config/routes';

const getFeatureFlags = (): ApiResponse => v3Get(routes.backendUrl.featureFlags.getFeatureFlags);

export const featureFlagApi = {
  getFeatureFlags,
};
